import BaseModel from '../core/BaseModel'
export default class SalaryPricelistModel extends BaseModel {

    constructor() {
        super({ 
                name: "salary_pricelist",
                tableName: 'salary_pricelist', 
                label: "Bảng giá tính lương", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true,  
                display: false
            },
            office_tpl_ref: { 
                refs: 'office_tpl {id code}',
                display: false
            },
            display_office_tpl: {
                name: 'display_office_tpl', 
                label: 'Mã văn phòng',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_office_tpl = '';
                    if(data.office_tpl !== undefined && data.office_tpl !== null){
                        data.display_office_tpl = data.office_tpl.code;
                    }
                }
            },
            district_ref: { 
                refs: 'district {id name}',
                display: false
            },
            display_district: {
                name: 'display_district', 
                label: 'Quận / Huyện',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_district = '';
                    if(data.district !== undefined && data.district !== null){
                        data.display_district = data.district.name;
                    }
                }
            },
            ward_ref: { 
                refs: 'ward {id name}',
                display: false
            },
            display_ward: {
                name: 'display_ward', 
                label: 'Phường / Xã',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_ward = '';
                    if(data.ward !== undefined && data.ward !== null){
                        data.display_ward = data.ward.name;
                    }
                }
            },
            type1_normal: {
                name: 'type1_normal', 
                type: "Currency",
                label: 'Loại 1 - Thường',
                width: 10,
                class: "center",
            },
            type1_late: {
                name: 'type1_late', 
                type: "Currency",
                label: 'Loại 1 - Trễ',
                width: 8,
                class: "center",
            },
            type2_normal: {
                name: 'type2_normal', 
                type: "Currency",
                label: 'Loại 2 - Thường',
                width: 10,
                class: "center", 
            },
            type2_late: {
                name: 'type2_late', 
                type: "Currency",
                label: 'Loại 2 - Trễ',
                width: 8,
                class: "center",
            },
            type3_normal: {
                name: 'type3_normal', 
                type: "Currency",
                label: 'Loại 3 - Thường',
                width: 10,
                class: "center",
            },
            type3_late: {
                name: 'type3_late', 
                type: "Currency",
                label: 'Loại 3 - Trễ',
                width: 8,
                class: "center", 
            },
            type4_normal: {
                name: 'type4_normal', 
                type: "Currency",
                label: 'Loại 4 - Thường',
                width: 10,
                class: "center",
            },
            type4_late: {
                name: 'type4_late', 
                type: "Currency",
                label: 'Loại 4 - Trễ',
                width: 8,
                class: "center", 
            },
        },)
    }

}